<template>
  <div class="h-dialogContainer">
    <div class='col-sm-4'>
      <ServerDetailLeft :detailShow="detailShow" :detailInfo="detailInfo"></ServerDetailLeft>
    </div>
    <div class='col-sm-8'>
      <div class='row h-row-insertBox'>
        <div class='col-sm-6 h-col-insertBox'>
          <div class='h-inputLit'>{{this.$t('环境')}}</div>
          <ejs-textbox class='e-input e-disabled' v-model='runEnvironment' disabled='false'></ejs-textbox>
        </div>
      </div>
      <div class='row h-row-insertBox'>
        <div class='col-sm-6 h-col-insertBox'>
          <div class='h-inputLit'>{{this.$t('实例名称')}}</div>
          <ejs-textbox class='e-input e-input-group' v-model='instanceName' disabled='false'></ejs-textbox>
        </div>
        <div class='col-sm-6 h-col-insertBox'>
          <div class='h-inputLit'>{{this.$t('副本个数')}}</div>
          <ejs-textbox class='e-input e-input-group' v-model='instanceNum' disabled='false'></ejs-textbox>
        </div>
      </div>
      <div class='row h-row-insertBox'>
        <div class='col-sm-6 h-col-insertBox'>
          <div class='h-inputLit'>{{this.$t('实例描述')}}</div>
          <ejs-textbox class='e-input e-input-group' v-model='instanceDes' disabled='false'></ejs-textbox>
        </div>
        <div class='col-sm-6 h-col-insertBox'>
          <div class='h-inputLit'>{{this.$t('节点')}}</div>
          <ejs-textbox class='e-input e-input-group' v-model='node' disabled='false'></ejs-textbox>
        </div>
      </div>
      <div class='row h-row-insertBox'>
        <div class='h-col-insertBox'>
          <div class='h-inputLit'>{{this.$t('版本选择')}}</div>
          <ejs-grid ref='grid' :commandClick='onClick'>
            <e-columns>
              <e-column field='deliverName' headerText='交付方式' width='70'></e-column>
              <e-column field='deliverVersion' headerText='交付版本' width='200' textAlign='Middle'></e-column>
              <e-column field='exist' headerText='是否存在软件包' width='90' textAlign='Middle'></e-column>
              <e-column headerText='操作' width='90' textAlign='Middle' :commands='commands'></e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CommandColumn  } from "@syncfusion/ej2-vue-grids";
import ServerDetailLeft from "../ServerDetailLeft";
import { EventBus } from '../../../plugins/eventBus';
import {stringify} from 'qs';

export default {
  name: 'ServerVersion',
  components: {
    ServerDetailLeft
  },
  provide: {
    grid: [ CommandColumn ]
  },
  data() {
    return {
      instanceName: '',
      instanceNum: '',
      instanceDes: '',
      runEnvironment: '',
      node: '',
      neid: '',
      dataSource: [],
      detailShow: {
        description: true,
        deliverType: true,
        createTime: false
      },
      detailInfo: {
        serviceName: '',
        description: '',
        deliverType: '',
        createTime: ''
      },
      commands: [{ buttonOption: { content: '升级', cssClass: 'e-flat'}}],
      oamTypeCode: 0,
      upOrBack: 0,
      deliverMap: { // 交付方式 0:native 老的enb和epc包 / 1:image 镜像包 / 2:helm 5GC包
        0: 'native',
        1: 'image',
        2: 'helm'
      },
      existMap: {
        0: '存在',
        1: '不存在'
      },
      oprMap: {
        0: '升级',
        1: '回退'
      },
      data: {},
    }
  },
  methods: {
    init(param) {
      // 初始参数赋值
      console.log(param);
      const data = param['dataSource'];
      this.neid = data[0]['serviceId'] + "";
      this.oamTypeCode = param['oamTypeCode'];
      this.upOrBack = param['upOrBack'];
      this.instanceName = data[0]['dname'];
      this.instanceNum = data.length;
      this.runEnvironment = data[0]['runEnvironment'];
      this.instanceDes = '';
      this.node = '';
      this.dataSource = data;
      this.detailInfo = {
        serviceName: data[0]['oamTypeCode'],
        description: '',
        deliverType: data[0]['deliverType'],
        createTime: ''
      };
      this.commands[0]['buttonOption']['content'] = this.oprMap[this.upOrBack];
      this.getList();
    },
    getList() {
      const url = "/lte/ems/packageManager/findUpBackPackage";
      const params = {
        oamTypeCode: this.oamTypeCode
      };
      this.axios.get(url, { params }).then(res => {
        const result = res.data;
        const adapter = result.filter(item => item.pkgType === 0);
        const pkg = result.filter(item => item.pkgType === 1).map(item => {
          const { packageName, pkgVersion } = item;
          return {
            packageName,
            pkgVersion
          }});
        const serverPkg = result.filter(item => item.pkgType === 2).map(item => {
          const { packageName, pkgVersion } = item;
          return {
            packageName,
            pkgVersion
          }});
        const showRe = [];
        adapter.forEach(item => {
          const re = { upVersion: [] };
          re.deliverType = item.deliverType
          re.deliverName = this.deliverMap[item.deliverType];
          re.deliverVersion = item.pkgVersion;
          const tempN = pkg.filter(it => it.packageName === item.packageName);
          const tempS = serverPkg.filter(it => it.packageName === item.packageName);
          if (Object.keys(tempN).length === 2) {
            // native 类型，检查是否存在升级包pkg(2个)
            re.existNum = 0;
            re.pkgType = 1;
            re.upVersion = tempN.map(re => re.pkgVersion);
          } else if (Object.keys(tempS).length === 1) {
            // image/helm类型，检查是否存在软件包
            re.existNum = 0;
            re.pkgType = 2;
            re.upVersion = tempS.map(re => re.pkgVersion);
          } else {
            re.existNum = 1;
          }
          re.exist = this.existMap[re.existNum];
          showRe.push(re);
        });
        this.$refs.grid.ej2Instances.dataSource = showRe;
      });
    },
    onClick(args) {
      this.data = args.rowData;
      console.log('onClick');
      console.log(this.data);
      if (this.data.existNum === 1) {
        this.eventEmit('warning', `${this.$t("软件包不存在，无法进行当前操作")}`);
        return null;
      }
      this.$layer.confirm({
        msg: this.data.deliverType === 0 ? '此服务下所有网元一起升级，是否继续？' : '确认执行升级操作？',
        btn1: {
          msg: this.$t('MCS.confirm'),
          func: this.confirm
        }
      });
    },
    confirm(){
      let url = '';
      const params = this.getData();
      if (this.upOrBack === 0) {
      //  升级
        if (this.data.deliverType === 0) {
          url = '/lte/ems/packageManager/upgradeDevice?' + stringify(params['urlParam']);
        } else if (this.data.deliverType === 1) {
          url = '/lte/ems/packageManager/upgrade5gc';
        } else {
          url = '/lte/ems/packageManager/upgradeDp';
        }
      } else {
        if (this.data.deliverType === 0) {
          url = '/lte/ems/packageManager/backDevice';
        } else if (this.data.deliverType === 1) {
          url = '/lte/ems/packageManager/back5gc';
        } else {
          url = '/lte/ems/packageManager/backDp';
        }
      }
      const data = {
        // 服务单个升级
        neIds: [this.neid],
        versionList: params['versionList']
      };
      this.$axios.post(url, data).then(res => {
        const result = res.data;
        console.log(result);
      });
    },
    getData() {
      const params = {
        versionList: this.data.upVersion,
        urlParam: {
          //  native 服务需要设置 isDownLoad, isActive, isUpLoad, execTime, isFilter 字段
          isDownLoad: 1,
          isActive: 1,
          isUpLoad: 1,
          isFilter: 0,
          execTime: new Date().Format("yyyy-MM-dd HH:mm:ss"),
        }
      };
      return params;
    },
    eventEmit(type, content) {
      EventBus.$emit('toast', {type: type, content: content})
    }
  },
}
</script>
